export default "/assets/website/images/stars.png?db8cfc01677e04ee07996520e2332645";